module.exports = __webpack_public_path__ + "43e834360e308c9f6bb31b241cccc20c.svg";